// extracted by mini-css-extract-plugin
module.exports = {"inline":"SubmitSystemTaskButton-styles-module--inline--32APf"};